


























































































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';

const name = 'catalog-select-template';
const defaultValue = 'all_template';
export default defineComponent({
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array as PropType<
        {
          label: string;
          value: string;
          disabled: boolean;
        }[]
      >,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);

    const select = computed({
      get: () => {
        if (value.value) {
          return value.value;
        }
        return defaultValue;
      },
      set: (val: string) => {
        if (val === defaultValue) {
          emit('input', '');
          return;
        }
        emit('input', val);
      },
    });

    return {
      defaultValue,
      name,
      select,
    };
  },
});
